import { Grid } from '@mui/material';
import { SiteInfoBox } from './ReviewSiteInfoBox';

interface Site {
  name: string;
  price: number | null;
  rating: number| null;
  count: number| null;
  url: string| null;
}

interface SiteInfoGridProps {
  sites: Site[];
}

export const SiteInfoGrid = ({ sites }: SiteInfoGridProps) => {
  return (
    <Grid
      container
      spacing={0}
      justifyContent="space-evenly"
      sx={{
        flexGrow: 1,
        minWidth: 0,       // ★ 親が縮められるように
        overflow: 'hidden' // はみ出し防止
      }}
    >
      {sites.map((site, idx) => (
        <Grid
          key={idx}
          sx={{
            minWidth: 0, // ★ 各セルも縮められるように
          }}
        >
          <SiteInfoBox
            name={site.name}
            price={site.price}
            rating={site.rating}
            count={site.count}
            url={site.url}
          />
        </Grid>
      ))}
    </Grid>
  );
};
